'use client';

import * as React from 'react';
import { showExcerptAtom } from 'app/blog/[domain]/_components/design-state';
import { useAtomValue } from 'jotai';

export function Excerpt({ excerpt }: { excerpt: string }) {
  const showExcerpt = useAtomValue(showExcerptAtom);
  if (!showExcerpt) {
    return <></>;
  }
  return <p className="post-header-excerpt">{excerpt}</p>;
}
